// extracted by mini-css-extract-plugin
export var active = "CatagoryItem-module--active--09989";
export var contentWrapper = "CatagoryItem-module--contentWrapper--aad84";
export var imageContainer = "CatagoryItem-module--imageContainer--3d080";
export var item = "CatagoryItem-module--item--22c93";
export var label = "CatagoryItem-module--label--74b19";
export var sliderItem = "CatagoryItem-module--sliderItem--e6ade";
export var tag = "CatagoryItem-module--tag--67f0a";